<template>
    <full-card>
        <template slot="header">
                <div class="">
                    <div class="flex justify-between items-center">
                        <button-secondary @click="prev()" class="mr-2">
                            <template slot="icon"><i class="fa fa-calendar-minus-o"></i></template>
                        </button-secondary>
                        <div>{{ showDate }}</div>
                        
                        <button-secondary @click="next()">
                            <template slot="icon"><i class="fa fa-calendar-plus-o"></i></template>
                        </button-secondary>
                    </div>
                </div>
            </template>
        <div v-if="!loading">
            <chart-line :datasets="data" :labels="labels"></chart-line>
        </div>
    </full-card>
</template>

<script>
import FullCard from "../components/UI/FullCard";
import ChartLine from "../components/Chart/ChartLine";
import moment from "moment";
import ButtonSecondary from "../components/UI/ButtonSecondary"

export default {
    name: "HourlyAttendanceStatistic",
    components: {
        FullCard,
        ChartLine,
        ButtonSecondary
    },

    data: () => ({
        date: new Date(),
        loading: false,
        data: [],
        labels: [],
        showDate: '',
    }),

    mounted() {
        this.load(this.date);
    },

    watch: {
        loading(curr,prev){
          this.$emit('setLoading', curr);
        }
    },


    methods: {
        next() {
            this.date = moment(this.date).add(1, 'day');
            this.load(this.date._d);
        },
        prev() {
            this.date = moment(this.date).subtract(1, 'day');
            this.load(this.date._d);
        },
        download() {
            window.open('/admin/statistics/export');
        },
        load(date) {
            this.loading = true;
            window.axios.get('/admin/hourly_stats', {
                params: {
                    date: date,
                }
            }).then(result => {
                this.loading = false;
                this.data = [{
                    label: 'Gebuchte Schreibtische',
                    data: Object.values(result.data.data),
                    borderColor: '#F1948A',
                    fill: false,
                    tension: 0.1,
                },
                ] 
                this.labels = Object.keys(result.data.data);
                this.showDate = result.data.day;
            }).catch(error => {
                this.$root.$emit('error', error);
            })

        },
    }

}
</script>

<style>

</style>